import { ownerPrincipalValidationInfoConstants } from "./ownerPrincipalValidationInfo.constants";

export const ownerPrincipalValidationInfoActions = {
	removeSignerValidationInfo,
	removeOwnerValidationInfo,
	setSsnValid,
};

function removeOwnerValidationInfo(index) {
	return {
		type:
			ownerPrincipalValidationInfoConstants.REMOVE_OWNER_VALIDATION_INFO,
		index,
	};
}

function removeSignerValidationInfo() {
	return {
		type:
			ownerPrincipalValidationInfoConstants.REMOVE_SIGNER_VALIDATION_INFO,
	};
}

function setSsnValid({ owners, signer }) {
	return {
		type:
			ownerPrincipalValidationInfoConstants.VALIDATION_INFO_SET_SSN_VALID,
		owners,
		signer,
	};
}
